import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { SafeHtmlPipe } from '../../../../shared/pipes/safe-html-pipe';

@Component({
  selector: 'app-application-visualization-dialog',
  imports: [SafeHtmlPipe, Button],
  templateUrl: './application-visualization-dialog.html',
  styleUrl: './application-visualization-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationVisualizationDialog {
  protected readonly dynamicDialogRef = inject(DynamicDialogRef);
  protected content = input<string>('');

  printSection(): void {
    const root = document.getElementById('print-root');
    if (!root) {
      return;
    }

    root.innerHTML = this.content();
    const pages = Array.from(root.children) as HTMLElement[];

    pages.forEach((page) => {
      page.style.marginTop = '0';
      page.style.marginBottom = '0';
      page.style.height = '1245px';
    });

    setTimeout(() => {
      window.print();
      root.innerHTML = '';
    }, 0);
  }
}
